import * as React from 'react';
import { IPersonProfileRelationData } from './PersonProfileDomainModel';
import * as Fetch from "../../../common/utils/Fetch";
import AccessesChangesTable, { IAccessChangeRow } from '../../../common/controls/RelationAccesses/AccessesChangesTable';

interface IProps {
	data: IPersonProfileRelationData
}

export default function RequiredAccessesPreview(props: IProps) {

	const [loading, setLoading] = React.useState(false);
	const [rows, setAccessChangeRow] = React.useState<IAccessChangeRow[]>(null);

	function loadAccesses() {

		setLoading(true);

		let from = null;
		let to = null;
		if (props.data.from) {
			if (props.data.from.toISOString)
				from = props.data.from.toISOString();
			else
				from = props.data.from;
		}
			
		if (props.data.to) {
			if (props.data.to.toISOString)
				to = props.data.to.toISOString();
			else
				to = props.data.to;
		}
		return Fetch
			.get<any>("/PersonProfile/GetAccessesDifference", {
				employee: props.data.employee.id,
				personProfile: props.data.resource.id,
				from: from,
				to: to,
			})
			.then(data => {
				setLoading(false);
				let rows: IAccessChangeRow[] = data.changes;

				setAccessChangeRow(rows);
			});
	}

	React.useEffect(() => {
		loadAccesses();
	}, [props.data.from, props.data.to]);

	return <AccessesChangesTable items={rows} resourceName={props.data.resource.name} loading={loading} />;
}